import { Spinner as BootstrapSpinner } from "react-bootstrap";
import styled from "styled-components";
import { COLOR_WHITE } from "../constants/colors";

const Spinner = styled(BootstrapSpinner)<{ size: string; borderWidth: string }>`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  color: ${COLOR_WHITE};
  margin: auto;
  border-width: ${(props) => props.borderWidth};

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-width: 0.25rem;
  }
`;
export default Spinner;

Spinner.defaultProps = {
  size: "100px",
  borderWidth: "0.5rem",
};
